import {
  TruncatedArticleList,
  VnewsTeaserCardRecommendedLex,
} from "components/page-components/Teaser-Cards"

import React from "react"

export const RecommendedArticlesWissen = ({
  articles,
  title,
  defaultNewsThumbnail,
}) => {
  return (
    <div data-nosnippet>
      <p className="title is-4">
        {articles?.[0]?.frontmatter?.category === "news"
          ? `Aktuelle Nachrichten zu "${title}"`
          : `Passende Beiträge zu "${title}"`}
      </p>
      <div className="section px-0 py-3">
        {articles?.slice?.(0, 3)?.map((article, index) => (
          <VnewsTeaserCardRecommendedLex
            {...{ article, defaultNewsThumbnail }}
            key={`post-link-number-${index}`}
          />
        ))}
      </div>

      {articles?.length >= 4 ? (
        <TruncatedArticleList
          {...{
            listedArticles: articles.slice(3),
          }}
        />
      ) : null}
    </div>
  )
}
